type DemoFixtures = typeof import('./fixtures');

let pending: Promise<DemoFixtures> | undefined;
let loaded: DemoFixtures | undefined;

/** Shares one on-demand import across store and fetch requests; a failed import can be retried. */
export function loadDemoFixtures() {
  pending ??= import('./fixtures').then(
    (fixtures) => {
      loaded = fixtures;
      return fixtures;
    },
    (error: unknown) => {
      pending = undefined;
      throw error;
    }
  );
  return pending;
}

/** Reads already-loaded fixture helpers for synchronous teardown and upload notifications. */
export const loadedDemoFixtures = () => loaded;
